import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { FileListDisplayMode, MinutesDisplayMode } from 'enums/app'

type EventDetailPageStateType = {
  projectId: string | undefined
  isExpandedDescription: boolean
  showMeetingPanel: boolean
  selectedFileListDisplayMode: string
  selectedMinutesDisplayMode: string
  scrollToTranscribeId: string | undefined
}

const initialEventDetailPageState: EventDetailPageStateType = {
  projectId: undefined,
  isExpandedDescription: false,
  showMeetingPanel: false,
  selectedFileListDisplayMode: FileListDisplayMode.List.id,
  selectedMinutesDisplayMode: MinutesDisplayMode.Minutes.value,
  scrollToTranscribeId: undefined,
}

export const eventDetailPageSlice = createSlice({
  name: 'eventDetailPage',
  initialState: initialEventDetailPageState,
  reducers: {
    setProjectId: (state, action: PayloadAction<string | undefined>) => {
      state.projectId = action.payload
    },

    updateIsExpandedDescription: (state, action: PayloadAction<boolean>) => {
      state.isExpandedDescription = action.payload
    },

    showMeetingPanelUpdated: (state, action: PayloadAction<boolean>) => {
      state.showMeetingPanel = action.payload
    },

    setSelectedFileListDisplayMode: (state, action: PayloadAction<string>) => {
      state.selectedFileListDisplayMode = action.payload
    },

    setSelectedMinutesDisplayMode: (state, action: PayloadAction<string>) => {
      state.selectedMinutesDisplayMode = action.payload
    },
    setScrollToTranscribeId: (
      state,
      action: PayloadAction<string | undefined>
    ) => {
      state.scrollToTranscribeId = action.payload
    },
  },
})

export const {
  setProjectId,
  updateIsExpandedDescription,
  showMeetingPanelUpdated,
  setSelectedFileListDisplayMode,
  setSelectedMinutesDisplayMode,
  setScrollToTranscribeId,
} = eventDetailPageSlice.actions
